import * as React from 'react';
import { useSelector } from 'react-redux';
import { Responsive } from '@cian/ui-kit';

import { ISpecialistCatalogListingSchema } from '../../repositories/demand/entities/specialist_catalog/SpecialistCatalogListingSchema';
import {
  AboutRealtorMobile,
  AdditionalInfoMobile,
  GeneralInfoMobile,
  PhotoMobile,
} from '../../components/AboutRealtorMobile';
import { OneStarRate } from '../../components/OneStarRate';
import { selectCurrentRealtor } from '../../selectors/selectCurrentRealtor';
import { ChatStatisticsMobileContainer } from '../ChatStatisticsMobileContainer';
import { getRateType } from '../../utils/getRateType';
import { IAgent } from '../../models/agent';
import { realtorInfoApi } from '../../api/realtorInfoApi';

export const AboutRealtorMobileContainer = () => {
  /** полагаем, что значения здесь не могут быть пустыми */
  const { reviewsRate, cianUserId } = useSelector(selectCurrentRealtor) as ISpecialistCatalogListingSchema;

  const { data } = realtorInfoApi.endpoints.getRealtorInfo.useQueryState({
    cianUserId,
  });

  const { age, name, avatarUrl, companyName, regionsNames, experience, skills, moderationInfo } = data?.agent as IAgent;
  const responseRateType = data?.chatsStatistics?.responseRate ? getRateType(data.chatsStatistics.responseRate) : null;
  const isSuperAgentStarShown = moderationInfo?.qualityLevelInfo?.showSuperAgent;

  return (
    <AboutRealtorMobile
      responseRateType={responseRateType}
      generalInfo={<GeneralInfoMobile name={name} companyName={companyName} age={age} />}
      chatStatistics={<ChatStatisticsMobileContainer />}
      photo={
        <>
          <Responsive phone>
            <PhotoMobile size={70} url={avatarUrl} isSuperAgentStarShown={isSuperAgentStarShown} />
          </Responsive>
          <Responsive tablet>
            <PhotoMobile size={100} url={avatarUrl} isSuperAgentStarShown={isSuperAgentStarShown} />
          </Responsive>
        </>
      }
      rate={<OneStarRate reviewsRate={Number(reviewsRate) || 0} size={'M'} uniqueKey={'AboutRealtorMobileContainer'} />}
      additionalInfo={<AdditionalInfoMobile experience={experience} regionsNames={regionsNames} skills={skills} />}
    />
  );
};

AboutRealtorMobileContainer.displayName = 'AboutRealtorMobileContainer';
